import { render, staticRenderFns } from "./JobCard2.vue?vue&type=template&id=3be1bb82&"
import script from "./JobCard2.vue?vue&type=script&lang=js&"
export * from "./JobCard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports